var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Timeline extends Component {
    constructor() {
        super('Timeline', false);
        this.currentIndex = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-timeline').length > 0) {
                $('.module-timeline .btn-prev').on('click', (event) => {
                    event.preventDefault();
                    this.prev();
                });
                $('.module-timeline .btn-next').on('click', (event) => {
                    event.preventDefault();
                    this.next();
                });
                $('.module-timeline--track a').on('click', (event, link) => {
                    event.preventDefault();
                    this.goto(link.index());
                });
                let touchStartX = 0;
                let touchEndX = 0;
                $('.module-timeline--content').on('touchstart', (event) => {
                    touchStartX = event.touches[0].clientX;
                });
                $('.module-timeline--content').on('touchend', (event) => {
                    touchEndX = event.changedTouches[0].clientX;
                    if (touchEndX < touchStartX)
                        this.next();
                    if (touchEndX > touchStartX)
                        this.prev();
                });
                $(window).on('resize', () => {
                    this.computeHeight();
                });
                this.computeHeight();
                setTimeout(() => {
                    this.computeHeight();
                }, 1000);
            }
            this.success();
        });
    }
    goto(index) {
        this.currentIndex = index;
        $('.module-timeline--content-event').removeClass('is-highlighted').eq(this.currentIndex).addClass('is-highlighted');
        $('.module-timeline--track').each((track) => {
            track.find('a').removeClass('active').eq(this.currentIndex).addClass('active');
        });
    }
    next() {
        this.currentIndex++;
        if (this.currentIndex >= $('.module-timeline--content-event').length)
            this.currentIndex = $('.module-timeline--content-event').length - 1;
        this.goto(this.currentIndex);
    }
    prev() {
        this.currentIndex--;
        if (this.currentIndex < 0)
            this.currentIndex = 0;
        this.goto(this.currentIndex);
    }
    computeHeight() {
        let height = 0;
        $('.module-timeline--content-event').each((event) => {
            const eventHeight = event.height();
            if (eventHeight > height)
                height = eventHeight;
        });
        $('.module-timeline--content').css('height', height + 24);
    }
}
